var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 58,
    viewBox: "0 0 46 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5342 34.7927C43.1054 34.7927 46 37.7129 46 41.3156V43.9795C46 45.6426 45.4848 47.264 44.5262 48.6171C40.0816 54.8915 32.824 58 22.9906 58C13.155 58 5.90118 54.8903 1.46733 48.6125C0.512916 47.2611 0 45.6432 0 43.9838V41.3156C0 37.7129 2.89479 34.7927 6.46571 34.7927H39.5342ZM22.9906 0C30.9299 0 37.3661 6.49304 37.3661 14.5026C37.3661 22.5122 30.9299 29.0052 22.9906 29.0052C15.0512 29.0052 8.61507 22.5122 8.61507 14.5026C8.61507 6.49304 15.0512 0 22.9906 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.a7a7080cc2b4a5d64d898f7e4efbe1f8.svg";
export { ForwardRef as ReactComponent };